import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '@/assets/images/logo-blue.svg';
import { ReactComponent as Email } from '@/assets/images/icons/mail.svg';
import { ReactComponent as FaceBook } from '@/assets/images/icons/facebook.svg';
import { ReactComponent as GitHub } from '@/assets/images/icons/github.svg';
import { ReactComponent as Instagram } from '@/assets/images/icons/instagram.svg';
import { ReactComponent as Linkedin } from '@/assets/images/icons/linkedin.svg';
import { ReactComponent as Twitter } from '@/assets/images/icons/twitter.svg';
import { GlobalContext } from '@/contexts/GlobalContext';

import './index.scss';

function ContactUs() {
  const { t } = useTranslation();
  const { setPageTitle, setTriggerFetchProfile } = useContext(GlobalContext);

  useEffect(() => {
    setPageTitle({
      title: t('contact_us_page.page_title'),
    });
    setTriggerFetchProfile(true);
  }, [setPageTitle, t, setTriggerFetchProfile]);

  return (
    <div className="contact-us-page">
      <div className="contact-us__header">
        <div className="contact-us-logo">
          <img src={Logo} alt="SMS2BUY" width="100%" height="100%" />
        </div>
        <div className="contact-us__info">
          <span className="phone-number contact fw-600">(+66)082-1208252</span>
          <span className="contact-us contact"> sales@sms2buy.com</span>
          <p className="desc contact">{t('contact_us_page.address')}</p>
        </div>
      </div>
      <div className="contact-us__media">
        <div className="icon-media email-icon">
          <Email />
        </div>
        <div className="icon-media facebool-icon">
          <FaceBook />
        </div>
        <div className="icon-media github-icon">
          <GitHub />
        </div>
        <div className="icon-media instagram-icon">
          <Instagram />
        </div>
        <div className="icon-media linkedin-icon">
          <Linkedin />
        </div>
        <div className="icon-media twitter-icon">
          <Twitter />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
